// Built-in text for the "About Our Fabric" section on the home page.
// Admins can override any of it from Admin → HomePage → About Our Fabric;
// anything not overridden falls back to these values.
// `image: ""` means the bundled about-fabric.gif.
export const ABOUT_FABRIC_DEFAULTS = {
  processTitle: "Custom Print Process",
  step1Text: "We will Develop Design",
  step1Highlight: "Develop Design",
  image: "",
  step2Text: "We will print on fabric of your choice",
  step2Highlight: "print",
  badge: "Premium Custom Fabric",
  heading: "About Our Fabric",
  intro1: "At Aavryaa, fabric is more than a material—it is the beginning of a masterpiece. Every design is thoughtfully curated to celebrate elegance, individuality, and timeless beauty, offering a luxurious canvas for extraordinary creations.",
  intro2: "Our collection showcases an exquisite range of premium fabrics adorned with exclusive signature prints, sophisticated florals, contemporary motifs, and bespoke designs—developed to combine aesthetic excellence with superior quality for designers, boutiques, fashion houses, and discerning clientele.",
  pills: ["Signature Prints", "Premium Fabric Bases", "Design Confidential", "Bespoke Development"],
  button1Text: "Explore Our Ideas",
  button2Text: "We will print on fabric of your choice",
  whatsappMessage: "Hi, I'm interested in custom fabric printing",
  story: "Driven by a passion for surface pattern design, we specialize in creating distinctive textile stories that transform creative visions into reality. From graceful ethnic wear and statement sarees to couture-inspired gowns, designer ensembles, and contemporary fashion collections, our fabrics are crafted to elevate every garment they become a part of.",
  bespokeTitle: "Bespoke Print Development",
  bespoke1: "Luxury lies in exclusivity. We offer customized fabric printing services that enable brands, designers, boutiques, and manufacturers to bring their unique concepts to life. From initial inspiration and artwork development to final production, every stage is executed with precision and attention to detail.",
  bespoke2: "Whether inspired by nature, art, heritage, or modern aesthetics, your ideas are translated into exceptional prints that reflect your signature style and brand identity.",
  specialtiesTitle: "Our Specialties",
  specialties: [
    "Exclusive Signature Floral Collections",
    "Bespoke Surface Pattern Designs",
    "Premium Quality Fabric Bases",
    "Custom Colourways & Design Development",
    "Boutique & Designer Exclusive Prints",
    "Fashion Brand Private Label Printing",
    "Ethnic, Contemporary & Fusion Wear Fabrics",
    "End-to-End Design Consultation",
  ],
  bulkTitle: "Bulk Production",
  bulkText: "We undertake bulk orders for customized prints tailored to your specific requirements.",
  minLabel: "Minimum Order",
  minValue: "100 Metres",
  minUnit: "per design",
  closing: "At Aavryaa, we create fabrics that inspire designers, empower brands, and transform imagination into timeless fashion.",
  tagline: "Where Art Meets Fabric. Where Fabric Becomes Fashion.",
};
